import { createContext, ReactNode, useEffect, useState } from "react";
import { de, Texts } from "../../translations/de";
import { en } from "../../translations/en";

type Locale = "de" | "en";

type LocaleContextProps = {
	texts: Texts;
	locale: Locale;
	setLocale: (locale: Locale) => void;
};

export const LocaleContext = createContext<LocaleContextProps>({
	texts: de,
	locale: "de",
	setLocale: () => {},
});

type LocaleContextProviderProps = {
	children: ReactNode;
};

export const LocaleContextProvider = ({
	children,
}: LocaleContextProviderProps) => {
	const [locale, setLocale] = useState<Locale>("de");
	const [texts, setTexts] = useState(de);

	useEffect(() => {
		setTexts(locale === "de" ? de : en);
	}, [locale]);

	return (
		<LocaleContext.Provider value={{ texts, locale, setLocale }}>
			{children}
		</LocaleContext.Provider>
	);
};
